import { PerformanceType } from '../queries/getPerformanceTrend/getPerformanceTrendQuery.type';

type PerformanceModalContent = {
  title: string;
  description: string;
};

export const PERFORMANCE_MODAL_CONTENT: Record<
  PerformanceType,
  PerformanceModalContent
> = {
  acceptance: {
    title: 'زمان پذیرش',
    description: `این شاخص مدت زمان بین ارجاع پرونده به کارشناس (یا قرار گرفتن پرونده در استخر پرونده‌های عمومی) تا زمان قبول نهایی پرونده توسط کارشناس را اندازه‌گیری می‌کند.
این زمان نشان می‌دهد پرونده پس از قرار گرفتن در دسترس کارشناس، چه مدت زمان می‌برد تا توسط او قبول و وارد فرآیند کارشناسی شود.`,
  },

  solve: {
    title: 'زمان رسیدگی',
    description: `این شاخص مدت زمان بین قبول پرونده تا ارسال گزارش کارشناسی را اندازه‌گیری می‌کند.
این بازه زمانی شامل مدت موردنیاز کارشناس برای تعیین زمان بازدید، کارشناسی پرونده، تکمیل و ارسال گزارش کارشناسی است. کاهش این زمان به معنی کوتاه‌تر شدن فرآیند کارشناسی پرونده است.`,
  },

  returns: {
    title: 'برگشتی',
    description: `این شاخص تعداد پرونده‌هایی که پس از بررسی توسط واحدهای بررسی و نظارتی، برای اصلاح یا تکمیل به کارشناس بازگردانده شده‌اند را نشان می‌دهد.
برگشت پرونده می‌تواند به دلایلی مانند نقص اطلاعات یا مدارک، خطا در محاسبات یا وجود ابهام در اطلاعات ثبت‌شده باشد. تعداد کمتر پرونده‌های برگشتی، نشان‌دهنده حرفه‌ای بودن و تسلط بالای کارشناس بر قوانین و استانداردهاست.`,
  },

  cancellations: {
    title: 'انصرافی',
    description:
      'این شاخص تعداد پرونده‌هایی را نشان می‌دهد که پس از ارجاع به کارشناس، توسط او پذیرفته نشده و مجدداً در فرآیند انتخاب کارشناس قرار گرفته‌اند. این وضعیت زمانی ثبت می‌شود که کارشناس پس از دریافت پرونده، آن را قبول نکند و پرونده برای انتخاب کارشناس جدید به چرخه ارجاع بازگردد.',
  },
};
